import { PureComponent } from 'react';

import {
  Divider,
  Flex,
  Header,
  PrimaryButton,
  Spacer,
  TertiaryButton,
  Text,
  Toolbar,
} from '@procurify/ui'
import { FormattedMessage } from 'react-intl'

import { FormattedEnhancedMessage } from '@webapp/core/hoc/FormattedEnhancedMessage'
import ErrorCSVIcon from './assets/import-csv-error.png'
import {
  ACCEPTED_CSV_FILE_TYPES,
  ACCEPTED_ZIP_MIME_TYPES,
  CSV_LABEL,
  ZIP_LABEL,
} from '../../constants'
import messages from '../../messages'
import { ImporterContentStyled as Content } from '../../styles/ImporterContentStyled'
import { ImporterUploaderContainerStyled } from '../../styles/ImporterUploaderContainerStyled'
import { ImporterUploader } from '../ImporterUploader/ImporterUploader'

export interface IImporterErrorStageProps {
  title?: string
  csvURL?: string
  failedRowCount?: number
  onDismiss?: () => void
  onCSVUpload?: (file) => void
  onCSVRemove?: () => void
  onSubmitCSVUpload?: () => void
  onAssetUpload?: (file) => void
  onAssetRemove?: () => void
  disableSubmitButton?: boolean
}

export interface IImporterErrorStageState {
  uploadedCSV: string
  uploadedAssets: string
}

export class ImporterErrorStage extends PureComponent<IImporterErrorStageProps> {
  render() {
    const { csvURL, failedRowCount, title } = this.props

    return (
      <Content width={660}>
        <Spacer />
        <img src={ErrorCSVIcon} alt='Importer error image' />
        <Header as='h3' gutter>
          <FormattedMessage
            values={{ failedRowCount }}
            {...messages.errorStepTitle}
          />
        </Header>
        <Text gutter align='center'>
          <FormattedEnhancedMessage {...messages.errorStepDescriptionTitle} />
        </Text>
        <Flex.Row justifyContent='center'>
          <Flex.Item maxWidth='30em'>
            <Text align='left' bold autoMargin={false}>
              <FormattedEnhancedMessage
                {...messages.errorStepDescriptionSubtitle}
              />
            </Text>
            <Text align='left'>
              <FormattedEnhancedMessage
                {...messages.errorStepDescriptionContentItemOne}
              />
              <br />
              <FormattedEnhancedMessage
                {...messages.errorStepDescriptionContentItemTwo}
              />
              <br />
              <FormattedEnhancedMessage
                {...messages.errorStepDescriptionContentItemThree}
              />
              <br />
              <FormattedEnhancedMessage
                {...messages.errorStepDescriptionContentItemFour}
              />
            </Text>
          </Flex.Item>
        </Flex.Row>

        <Spacer />

        <a href={csvURL} download>
          <PrimaryButton>
            <FormattedMessage {...messages.downloadErrors} />
          </PrimaryButton>
        </a>

        <Spacer space={2} />

        <Divider space={2} />

        <Header as='h5' gutter>
          <FormattedMessage {...messages.errorReminderToReupload} />
        </Header>

        <ImporterUploaderContainerStyled>
          <ImporterUploader
            id={title}
            icon='csv'
            onUpload={this.props.onCSVUpload}
            onFileRemove={this.props.onCSVRemove}
            validFileTypes={ACCEPTED_CSV_FILE_TYPES}
            validFileTypeName={CSV_LABEL}
          />
          <ImporterUploader
            id={`${title} assets`}
            icon='zip'
            onUpload={this.props.onAssetUpload}
            onFileRemove={this.props.onAssetRemove}
            validFileTypes={ACCEPTED_ZIP_MIME_TYPES}
            validFileTypeName={ZIP_LABEL}
          />
        </ImporterUploaderContainerStyled>

        <Spacer space={2} />

        <Toolbar>
          <Toolbar.Fill />
          <Toolbar.Item>
            <TertiaryButton onClick={this.props.onDismiss}>
              <FormattedMessage {...messages.errorStepCancelButton} />
            </TertiaryButton>
            <PrimaryButton
              disabled={this.props.disableSubmitButton}
              onClick={this.props.onSubmitCSVUpload}
            >
              <FormattedMessage {...messages.errorStepImportButton} />
            </PrimaryButton>
          </Toolbar.Item>
        </Toolbar>
      </Content>
    )
  }
}
